<template>
  <RevPagination
    :current-page
    :current-page-label="`${currentPage}`"
    navigation-aria-label="pagination"
    :next-aria-label="i18n(translations.nextAriaLabel)"
    :page-aria-label="(page) => i18n(translations.navigate, { page })"
    :page-count
    :pageURL="
      (page) =>
        withHtmlLinks
          ? `${route.path}${page > 1 ? `?p=${page}` : ''}${route.hash}`
          : ''
    "
    :previous-aria-label="i18n(translations.previousAriaLabel)"
    @click="handlePagination"
  />
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevPagination } from '@ds/components/Pagination'

import translations from './Pagination.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

defineProps<{ pageCount: number; withHtmlLinks?: boolean }>()
const currentPage = defineModel<number>({ required: true })
const route = useRoute()

function handlePagination({ page }: { page: number }) {
  currentPage.value = page

  trackClick({
    name: page,
    zone: 'pagination',
  })
}
</script>
